import { reducers } from './authenticated.reducers';
export const AuthenticatedStore = {
    featureKey: 'authenticated',
    reducers,
    initialState: null,
};
